import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { getColorFromThemeName } from '../../_config/utils';
import Tag from '../Tag.jsx';
import { GREEN } from '../../_config/consts.js';
import { CheckCircleOutline, RemoveCircleOutline } from '@material-ui/icons';

const styles = {
  container: {
    marginBottom: 10,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    },
  },
  selected: {
    border: '2px solid',
  },
  content: {
    padding: 15,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    margin: 0,
  },
  id: {
    fontSize: 14,
    color: '#666',
    margin: 0,
  },
  section: {
    marginTop: 15,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  lockContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: 5,
  },
  groupContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: 5,
  },
  groupTag: {
    backgroundColor: '#e0e0e0',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '14px',
  },
};

class VirtualIntercomRow extends React.Component {
  render() {
    const { classes, intercom, isSelected, onClick, themeColor } = this.props;
    const color = getColorFromThemeName(themeColor);

    return (
      <Card 
        className={classes.container} 
        style={isSelected ? { ...styles.selected, borderColor: color } : {}}
        onClick={onClick}
      >
        <div className={classes.content}>
          <div className={classes.header}>
            <h3 className={classes.title}>{intercom.name}</h3>
            <h4 className={classes.id}>ID: {intercom.id}</h4>
          </div>

          <div>
            <h5 style={{ margin: '10px 0' }}>
              {intercom.hyperTile?.serialNumber}
            </h5>
          </div>

          {intercom.groups && intercom.groups.length > 0 ? (
            <div className={classes.section}>
              <h5 className={classes.sectionTitle}><Entity entity="virtualIntercomExtensionGroups" /></h5>
              <div className={classes.groupContainer}>
                {_.map(_.sortBy(intercom.groups, 'id'), group => (
                  <span className="resourceInfoRow-typeTag-flat">
                    <h5 style={{ color: 'white', margin: 0 }}>{group.name}</h5>
                  </span>
                ))}
              </div>
            </div>
          ) : null}

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}><Entity entity="virtualIntercomSmartLocks" /></h5>
            <div className={classes.lockContainer}>
              {_.map(_.sortBy(intercom.smartLocks, 'id'), lock => (
                <Tag
                  key={lock.id}
                  tag={{type: 'lock', name: lock.name, color: '#ba68c8'}}
                  style={{ padding: 5 }}
                  textStyle={{ fontSize: 14 }}
                />
              ))}
            </div>
          </div>

          <div className={classes.section}>
            <h5 className={classes.sectionTitle}><Entity entity="virtualIntercomStatus" /></h5>
            <div className={classes.lockContainer} style={{ display: 'flex', alignItems: 'center' }}>
              <h5 style={{ color: intercom.enabled ? GREEN : 'grey', marginRight: 10 }}> <Entity key={intercom.enabled} entity={intercom.enabled ? 'virtualIntercomStatusEnabled' : 'virtualIntercomStatusDisabled'} /></h5>
              {intercom.enabled ? (
                <CheckCircleOutline style={{ fontSize: 20, color: GREEN }} />
              ) : <RemoveCircleOutline style={{ fontSize: 20, color: 'grey' }} />}
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

export default withStyles(styles)(VirtualIntercomRow); 